import type { ImgHTMLAttributes } from 'react';
export default function Image({ fill, priority, sizes, style, ...props }: ImgHTMLAttributes<HTMLImageElement> & { fill?: boolean; priority?: boolean }) {
  return <img {...props} sizes={sizes} decoding="async" loading={priority ? 'eager' : 'lazy'} style={{ ...(fill ? { position: 'absolute', inset: 0, width: '100%', height: '100%' } as const : {}), ...style }} />;
}
